export function SAVE_ROUTE_FROM(state, routeFrom) {
	state.route_from = routeFrom
}

export function SAVE_LOADING_ACTIVITIES(state, value) {
	state.loading_activities = value
}
